<template>
    <section class="quiz-diabetes-managment">
        <progress-bar :question-number="(currentIndex + 1)" :number-of-tabs="8" @goBack="back" :show-back-button="showBackButton"></progress-bar>

        <web-modal id="quiz" is-active>
            <template slot="content">
                <figure>
                    <img src="/imgs/web/svg/therapist.svg" alt="Wie gut bin ich in meinem Diabetes-Management? - Vitadio">
                </figure>

                <span class="new-headline-lg text-centered">Wie gut bin ich in meinem Diabetes-Management?</span>

                <p class="new-text-md text-centered">
                    Prüfen Sie Ihr Selbstvertrauen in den wichtigsten Bereichen des Diabetesmanagements. Bitte
                    wählen Sie für jede der folgenden Fragen die Zahl aus, die Ihrer Zuversicht entspricht, dass
                    Sie die Aufgaben ab jetzt regelmäßig erledigen können.
                </p>

                <v-button
                    href="#"
                    aria-hidden="true"
                    data-dismiss="modal"
                    size="lg"
                    position="center"
                    label="Quiz starten"
                ></v-button>
            </template>
        </web-modal>

        <div class="container" v-if="this.quizPage">
            <div class="step">
                <span class="text-sm">Frage {{ this.currentIndex + 1 }} von 8</span>
            </div>
            <div class="question">
                <span class="headline-md">
                    {{ this.questions[this.currentIndex] }}
                </span>
            </div>
            <div class="score">
                <div class="scale scale--start section-title">überhaupt nicht sicher</div>
                <div
                    class="number"
                    :class="{ 'number--clicked': numberClicked === true && selectedNumber === item }"
                    v-for="(item, index) in 10"
                    :key="index"
                    @click="chooseNumber(item)"
                >
                    <template v-if="numberClicked === true && selectedNumber === item">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" class="svg-inline--fa fa-spinner fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg>
                    </template>
                    <span v-else class="headline-md">
                        {{ item }}
                    </span>
                </div>
                <div class="scale scale--end section-title">absolut sicher</div>
            </div>
        </div>
        <quiz-diabetes-managment-last
            v-if="!this.quizPage"
            :totalScore="this.totalScore"
            :answers="this.totalScores"
        ></quiz-diabetes-managment-last>
    </section>
</template>

<script>
    export default {
        props: {},
        data() {
            return {
                quizPage: true,
                questions: [
                    '1. Wie sicher sind Sie sich, dass Sie alle 4 bis 5 Stunden Ihre Mahlzeiten einnehmen können, einschließlich des täglichen Frühstücks?',
                    '2. Wie sicher sind Sie sich, dass Sie Ihre Diät einhalten können, wenn Sie Essen zubereiten oder mit anderen Menschen teilen müssen, die nicht an Diabetes leiden?',
                    '3. Wie sicher sind Sie sich, dass Sie die richtigen Lebensmittel auswählen können, wenn Sie wenn Sie hungrig sind (z. B. Snacks)?',
                    '4. Wie sicher sind Sie sich, dass Sie 15 bis 30 Minuten, 4 bis 5 Mal pro Woche trainieren können?',
                    '5. Wie sicher sind Sie sich, dass Sie etwas tun können, um zu verhindern, dass Ihr Blutzuckerspiegel nicht absinkt, wenn Sie Sport treiben?',
                    '6. Wie sicher sind Sie sich, dass Sie wissen, was zu tun ist, wenn Ihr Blutzuckerspiegel höher oder niedriger ist, als er sein sollte?',
                    '7. Wie sicher sind Sie sich, dass Sie einschätzen können, wenn die Veränderungen bei Ihrer Krankheit einen Arztbesuch erforderlich machen?',
                    '8. Wie sicher sind Sie sich, dass Sie Ihre Diabeteserkrankung so kontrollieren können, dass dass sie Sie bei all den Dingen, die Sie tun möchten, nicht beeinträchtigt?'
                ],
                totalScores: [],
                totalScore: 0,
                currentIndex: 0,
                numberClicked: false,
                selectedNumber: null,
                showBackButton: false
            }
        },

        watch: {
            currentIndex() {
                if (this.currentIndex > 0) {
                    this.showBackButton = true
                } else {
                    this.showBackButton = false
                }
            }
        },

        methods: {
            chooseNumber(selectedNumber) {
                this.selectedNumber = selectedNumber
                this.numberClicked = true

                setTimeout(() => {
                    if (this.currentIndex < this.questions.length - 1) {
                        this.totalScores.push(selectedNumber)
                        this.currentIndex = this.currentIndex + 1
                        window.scrollTo(0, 0)
                        this.selectedNumber = null
                    } else {
                        this.totalScores.push(selectedNumber)
                        this.currentIndex = this.currentIndex + 1
                        this.countTotalScore()
                        this.quizPage = false
                        this.selectedNumber = null
                    }

                    this.numberClicked = false
                }, 1000)
            },

            countTotalScore() {
                this.totalScore = 0

                for (const score of this.totalScores) {
                    this.totalScore = this.totalScore + score
                }
            },

            back() {
                if (this.currentIndex === this.questions.length) {
                    this.quizPage = true
                }

                this.currentIndex = this.currentIndex - 1
                this.totalScores.pop()
                this.countTotalScore()
            }
        }
    }
</script>
